import { render, staticRenderFns } from "./contentVideoMobile.vue?vue&type=template&id=854907ec&scoped=true&"
import script from "./contentVideoMobile.vue?vue&type=script&lang=js&"
export * from "./contentVideoMobile.vue?vue&type=script&lang=js&"
import style0 from "./contentVideoMobile.vue?vue&type=style&index=0&id=854907ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854907ec",
  null
  
)

export default component.exports